<template>
  <a-result status="404" title="404" sub-title="Sorry, the page you visited does not exist.">
  </a-result>
</template>
<script>
export default {
  name: 'NotFoundPage'
};
</script>